export default {
  underline: {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      justifyContent: `start`,
      m: 0,
      p: 0,
      marginLeft: '5%',
      mt: '4rem',
      '@media (max-width: 860px)': {
        display: `-webkit-inline-box`,
        overflow: 'overlay',
        width: '100%',
        marginLeft: '0',
      },
      '&::-webkit-scrollbar': { 
        display: 'none' 
      }
    },
    '.tabs_tab': {
      variant: `text.h5`,
      fontWeight: `medium`,
      cursor: `pointer`,
      transition: `all 400ms ease`,
      color: `#D4D2DF`,
      borderBottomColor: `transparent`,
      borderBottomWidth: `md`,
      borderBottomStyle: `solid`,
      outline: `none`,
      px: 4,
      pb: 3,
      m: 25,
      '@media (max-width: 480px)': {
        fontSize: '15px',
        m: '5px',
        paddingRight: '0.5rem',
        paddingLeft: '0.5rem',
      },
      ':not(.tabs_selectedTab):hover': {
        color: `omegaDarker`,
        borderBottomColor: `#2A205E`,
        '@media (max-width: 860px)': {
          color: `#27A8FF`,
          borderBottomColor: `#27A8FF`,
        },
      }
    },
    '.tabs_selectedTab': {
      color: `#2A205E`,
      borderBottomColor: `#2A205E`,
      '@media (max-width: 860px)': {
        color: `#27A8FF`,
        borderBottomColor: `#27A8FF`,
      },
    },
    '.react-tabs__tab-panel:not([class$="--selected"])': {
      display: `none`
    },
  },
  pill: {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      justifyContent: `center`,
      m: 0,
      p: 0,
    },
    '.tabs_tab': {
      minWidth: [`auto`, 200],
      display: `flex`,
      alignItems: `center`,
      justifyContent: `center`,
      listStyle: `none`,
      cursor: `pointer`,
      transition: `all 400ms ease`,
      bg: `white`,
      color: `alphaDark`,
      boxShadow: `0 0 35px rgba(140,152,164,.2)`,
      outline: `none`,
      px: 4,
      py: 3,
      m: 0,
      ':last-of-type': {
        borderRadius: t => `0 ${t.radii.xl} ${t.radii.xl} 0`
      },
      ':first-of-type': {
        borderRadius: t => `${t.radii.xl}  0 0 ${t.radii.xl}`
      },
      ':not(.tabs_selectedTab):hover': {
        bg: `alphaDark`,
        color: `white`
      }
    },
    '.tabs_tab + .tabs_tab': {
      ml: `1px`
    },
    '.tabs_selectedTab': {
      bg: `alphaDark`,
      color: `white`
    }
  },
  dots: {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      justifyContent: `center`,
      m: 0,
      p: 0
    },
    '.tabs_tab': {
      listStyle: `none`,
      size: `14px`,
      textIndent: `-9999px`,
      bg: `omega`,
      borderRadius: `full`,
      cursor: `pointer`,
      mx: 1,
      ':not(.tabs_selectedTab):hover': {
        bg: `omegaDarker`
      }
    },
    '.tabs_selectedTab': {
      bg: `alphaDark`
    }
  },
  arrowButton: {
    minWidth: `auto`,
    borderWidth: `sm`,
    borderRadius: `full`,
    boxShadow: `0 0 35px rgba(140,152,164,.425)`,
    position: `absolute`,
    top: `50%`,
    p: 3,
    mr: 2
  },
  arrowButtonRight: {
    right: 0,
    transform: `translate(-50%, 50%)`
  },
  arrowButtonLeft: {
    left: 0,
    transform: `translate(50%, 50%)`
  },
  arrow: {
    size: `10px`,
    borderBottom: `3px solid currentColor`,
    borderLeft: `3px solid currentColor`
  },
}
